import React, { useState } from 'react';
import styled from "styled-components";
import Button, { ButtonProps } from '@material-ui/core/Button';
import { StyledInput, DeleteIconButton, Flex } from '../styles/global';
import deleteIcon from "../assets/delete.svg";

interface Props {
  blackouts?: any,
  setValue: (value: any) => void;
}

export const Blackout = ({ blackouts, setValue }: Props) => {
  const [balckoutList, setBlackoutList] = useState(blackouts || []);

  return (
    <div>
      {balckoutList.map((blackout: any, index: number) => {
        return (
          <BlackoutContaier key={index} alignItems="center">
            <StyledInput
              $setWidth="150"
              type="time"
              variant="outlined"
              value={balckoutList[index]?.start_time}
              onChange={(e: { target: { value: any; }; }) => {
                let newBlackOut = [...balckoutList];
                newBlackOut[index].start_time = e.target.value;
                setBlackoutList(newBlackOut);
                setValue(newBlackOut);
              }}
              required
            />
            <LineWrapper>—</LineWrapper>
            <StyledInput
              $setWidth="150"
              type="time"
              variant="outlined"
              value={balckoutList[index]?.end_time}
              onChange={(e: { target: { value: any; }; }) => {
                let newBlackOut = [...balckoutList];
                newBlackOut[index].end_time = e.target.value;
                setBlackoutList(newBlackOut);
                setValue(newBlackOut);
              }}
              required
            />
            <DeleteIconButton
              style={{ marginLeft: '12px' }}
              onClick={() => {
                let newBlackOut = [...balckoutList];
                newBlackOut.splice(index, 1);
                setBlackoutList(newBlackOut);
                setValue(newBlackOut);
              }}
            >
              <img src={deleteIcon} style={{ height: 24 }} alt="delete" />
            </DeleteIconButton>
          </BlackoutContaier>
        )
      })}
      <StyledButton
        size="large"
        variant="contained"
        disableElevation
        onClick={() => {
          let newBlackOut = balckoutList;
          newBlackOut.push({ start_time: "", end_time: "", days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] });
          setBlackoutList(newBlackOut);
          setValue(newBlackOut);
        }}
      >
        Add Blackout
      </StyledButton>
    </div>
  );
}

const StyledButton = styled(Button) <ButtonProps>`
  && {
    max-width: 280px;
  }
` as typeof Button;

const BlackoutContaier = styled(Flex)`
  margin-top: 24px;
  margin-bottom: 12px;
`;

const LineWrapper = styled.span`
  margin-left: 12px;
  margin-right: 12px;
  font-size: 24px;
  color: #333;
`;
